<template>
  <v-layout column>
    <v-layout row justify-space-between>
      <v-flex grow>
        <h5>{{name}}</h5>
      </v-flex>
      <v-flex shrink>
        <v-layout>
          <v-select
            v-model="selectedRideType"
            :items="items"
            item-value="id"
            item-text="name"
            label="Ride Type"
          ></v-select>
          <v-btn
            @click="addFixedCostRideType"
            class="text-none offset-align-select"
            color="blue"
            dark
          >Add Ride Type</v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-data-table
      v-if="fixedCostRideTypes != null"
      :rows-per-page-items="[25]"
      style="width: 100%"
      :headers="headers"
      :items="fixedCostRideTypes"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.ride_type.name }}</td>
          <td>{{ (props.item.cost / 100).toFixed(2) }}</td>
          <td>{{ props.item.cost_driver == 0 ? "-" : (props.item.cost_driver / 100).toFixed(2) }}</td>
          <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="updateFixedCostRideType(props.item)">edit</v-icon>
            <!-- <v-icon small @click="deleteFixedCostRideType(props.item)">delete</v-icon> -->
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog persistent v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                xs12
              >For trips with multiple pickups, the applicable tariff will be charged from pickup to the last 'via' point. The fixed cost will then be added on to create the final fare.</v-flex>
              <v-flex xs12>
                Set cost for driver to 0 if you do not wish to affect their amount paid for the trip.
                <br />
                <br />The driver will only be paid a different amount for card or account trips ( cash and card in cab trips clearly display a price to the driver and hence are not appropriate )
              </v-flex>
              <v-flex pt-3 xs12 sm6 md4>
                <v-text-field
                  v-model="editedFixedCostRideType.cost"
                  label="Cost for Customer"
                  type="number"
                ></v-text-field>
              </v-flex>
              <v-flex pt-3 xs12 sm6 md4>
                <v-text-field
                  v-model="editedFixedCostRideType.cost_driver"
                  label="Cost for Driver"
                  type="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <p style="color: red;">{{errorText}}</p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import qs from "qs";

import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "fixed_cost_details",
  props: {
    fixedCost: Object,
    name: String,
    rideTypes: { type: Array, default: null },
    forCustomer: { type: Boolean, default: false },
    customer: { type: Object, default: null }
  },
  data: function() {
    return {
      dialog: false,
      formTitle: "",
      editedFixedCostRideType: {
        cost: 0,
        cost_driver: 0
      },
      errorText: "",
      selectedRideType: "",
      headers: [
        {
          text: "Ride Type",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Cost", value: "calories", sortable: false },
        { text: "Cost (Driver)", value: "fat", sortable: false },
        { text: "", value: "carbs", sortable: false }
      ]
    };
  },
  mounted: function() {
    if (this.fixedCost.fixed_cost_ride_type == null) {
      this.fixedCost.fixed_cost_ride_type = [];
    }
  },
  computed: {
    fixedCostRideTypes: function() {
      console.log(
        "Fixed Cost Ride type " + this.fixedCost.fixed_cost_ride_type
      );
      return this.fixedCost.fixed_cost_ride_type;
    },
    items: function() {
      var items = [];

      var rideTypes = this.rideTypes;

      if (this.rideTypes != null) {
        for (var i = 0; i < this.rideTypes.length; i++) {
          if (
            this.fixedCost != null &&
            this.fixedCost.fixed_cost_ride_type != null
          ) {
            var found = this.fixedCost.fixed_cost_ride_type.find(function(
              item
            ) {
              return item.ride_type.id == rideTypes[i].id;
            });

            if (found != null) {
              console.log("FOUND");
              continue;
            }
          }

          items.push(this.rideTypes[i]);
        }
      }

      return items;
    }
  },
  methods: {
    addFixedCostRideType: function() {
      var selectedRideType = this.selectedRideType;

      var rideType = this.rideTypes.find(function(item) {
        return item.id == selectedRideType;
      });

      this.formTitle = rideType.name;

      this.editedFixedCostRideType = {
        cost: 0,
        cost_driver: 0,
        ride_type: rideType
      };

      this.dialog = true;
    },
    updateFixedCostRideType: function(fixedCostRideType) {
      var rideType = fixedCostRideType.ride_type;

      this.formTitle = rideType.name;

      this.editedFixedCostRideType = {
        id: fixedCostRideType.id,
        cost: (fixedCostRideType.cost / 100).toFixed(2),
        cost_driver: (fixedCostRideType.cost_driver / 100).toFixed(2),
        ride_type: rideType
      };

      this.dialog = true;
    },
    deleteFixedCostRideType: function(fixedCostRideType) {
      // TODO delete fixed cost ride type
    },
    close: function() {
      this.dialog = false;
    },
    save: function() {
      var url = `${this.$store.state.apiUrl}`;

      if (!this.forCustomer) {
        url += `/fixed_cost/${this.$route.params.id}/fixed_cost/ride_type/${this.editedFixedCostRideType.ride_type.id}`;
      } else {
        url += `/fixed_cost/${this.$route.params.id}/fixed_cost_customer/${this.customer.id}/fixed_cost/ride_type/${this.editedFixedCostRideType.ride_type.id}`;
      }

      try {
        var cost = parseInt(
          Math.floor(this.editedFixedCostRideType.cost * 100)
        );
        var cost_driver = parseInt(
          Math.floor(this.editedFixedCostRideType.cost_driver * 100)
        );

        if (cost < 0 || cost_driver < 0) {
          throw "number less than zero";
        }
      } catch (e) {
        this.errorText =
          "Please ensure costs are entered in the correct format (pounds and pence e.g. 85.00) and are greater than or equal to 0";
        console.log(e);
        return;
      }

      if (cost < cost_driver) {
        this.errorText =
          "Please ensure cost for customer is equal to or greater than cost for driver";

        return;
      }

      this.errorText = "";

      var completed = this.success;
      var failed = this.failed;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify({
          cost: cost,
          cost_driver: cost_driver
        }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            completed(res.data);
          } else {
            failed(res.data.error);
          }
        })
        .catch(function(err) {
          console.error(err);
          failed("internal_server_error");
        });
    },
    success: function() {
      this.dialog = false;

      if (this.editedFixedCostRideType.id == null) {
        // add the fixed cost ride type to the list with a temporary ID
        this.editedFixedCostRideType.id = 99992;

        this.editedFixedCostRideType.cost =
          this.editedFixedCostRideType.cost * 100;
        this.editedFixedCostRideType.cost_driver =
          this.editedFixedCostRideType.cost_driver * 100;

        this.fixedCost.fixed_cost_ride_type.push(this.editedFixedCostRideType);
      } else {
        // update the fields on the fixed cost ride type
        var editedFixedCostRideType = this.editedFixedCostRideType;

        var fixedCostRideType = this.fixedCost.fixed_cost_ride_type.find(
          function(item) {
            return item.ride_type.id == editedFixedCostRideType.ride_type.id;
          }
        );

        fixedCostRideType.cost = editedFixedCostRideType.cost * 100;
        fixedCostRideType.cost_driver =
          editedFixedCostRideType.cost_driver * 100;
      }
    },
    failed: function(e) {
      this.errorText = "Error: " + e;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.offset-align-select {
  margin-top: 10px;
}
table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}
</style>
